import { RepeatOrderFormValues } from "./RepeatOrderDialog"

import type { AppLocalization } from "../../../../../../modules/localization/appLocalization"

export const prepareInitialValues = (details?: Partial<RepeatOrderFormValues> | null): RepeatOrderFormValues => {
    return {
        repeatType: details?.repeatType ?? "day",
        repeatInterval: details?.repeatInterval ?? 1,
        startDate: details?.startDate ?? null,
        endType: details?.endType ?? "on",
        endDate: details?.endDate ?? null,
        repeatCount: details?.repeatCount ?? 2,
        weekDays: details?.weekDays ?? [],
    }
}

type L10n = Pick<AppLocalization, "getString">

export function formatRecurrence({
    values,
    l10n,
}: Readonly<{
    values: Partial<RepeatOrderFormValues>
    l10n: L10n
}>): string {
    const startDate = values.startDate
        ? values.startDate.toLocaleString({ month: "long", day: "numeric", year: "numeric" })
        : ""

    const repeatType = values.repeatType === "week" ? "week" : "day"
    const repeatIntervalCount = values.repeatInterval ?? 1

    const repeatInterval =
        repeatType === "week"
            ? repeatIntervalCount > 1
                ? l10n.getString("create-order-drawer-repeat-order-summary-interval-weeks", {
                      count: repeatIntervalCount,
                  })
                : l10n.getString("create-order-drawer-repeat-order-summary-interval-week")
            : repeatIntervalCount > 1
            ? l10n.getString("create-order-drawer-repeat-order-summary-interval-days", {
                  count: repeatIntervalCount,
              })
            : l10n.getString("create-order-drawer-repeat-order-summary-interval-day")

    const days =
        values.weekDays && values.weekDays.length
            ? l10n.getString("create-order-drawer-repeat-order-summary-days-suffix", {
                  days: values.weekDays.join(", "),
              })
            : ""

    const repeatCount = values.repeatCount
        ? l10n.getString("create-order-drawer-repeat-order-summary-repeat-count-suffix", { count: values.repeatCount })
        : ""

    const endDate = values.endDate
        ? l10n.getString("create-order-drawer-repeat-order-summary-end-date-suffix", {
              date: values.endDate.toLocaleString({ month: "long", day: "numeric", year: "numeric" }),
          })
        : ""

    return l10n.getString("create-order-drawer-repeat-order-summary", {
        interval: repeatInterval,
        days,
        startDate,
        repeatCount,
        endDate,
    })
}
